export function createSubmitData(formData) {

    let submitData = {
        dateAndTime: `${formData.date.format("YYYY-MM-DD")}T${formData.time.format("hh:mm:ss")}`,
    }

    let logs = []

    formData.equipment.forEach(item => {

        let log = {
            equipment: parseInt(item.id, 10),
            quantity: parseInt(item.amount, 10),
            reason: item.reason
        }

        logs.push(log)
    })

    submitData['logs'] = [...logs]

    return submitData
}
